
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tail-spend-management",
      function () {
        return require("private-next-pages/tail-spend-management/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tail-spend-management"])
      });
    }
  